import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteFetchList from './InfiniteFetchList';
import Avatar from './Avatar';

export default class CommunityActivitiesList extends Component {
  static propTypes = {
    perPage: PropTypes.number.isRequired,
    apiUrl: PropTypes.string.isRequired,
    noResultsMessage: PropTypes.string,
  };

  static defaultProps = {
    noResultsMessage: 'No activity yet.',
  };

  constructor(props) {
    super(props);
  }

  renderItem = (item, key) => {
    return (
      <div
        className="u-flex u-justify-between u-items-center u-py-2"
        key={`community-activity-item-${key}`}>
        <div>{this.renderActivity(item)}</div>
        <div dangerouslySetInnerHTML={{ __html: item.time_ago_html }} />
      </div>
    );
  };

  renderActivity(item) {
    return (
      <div className="u-flex u-items-center">
        {this.renderAvatar(item.user)}
        <span dangerouslySetInnerHTML={{ __html: item.summary_html }} />
      </div>
    );
  }

  renderAvatar(user) {
    return (
      <Avatar
        src={user.avatar.url}
        name={user.full_name}
        className="u-h-9 u-w-9 u-mr-2 u-flex-shrink-0"
      />
    );
  }

  render() {
    return (
      <div className="u-bg-white u-rounded u-px-4 u-pt-0 u-shadow u-border u-border-grey-light u-mb-8">
        <div className="u-flex u-justify-between u-font-semibold u-py-2 u-border-b u-border-grey-light u-text-sm">
          <div>ACTION</div>
          <div>TIMESTAMP</div>
        </div>

        <InfiniteFetchList
          apiUrl={this.props.apiUrl}
          perPage={this.props.perPage}
          itemRenderer={this.renderItem}
          noResultsMessage={this.props.noResultsMessage}
          loadingCardsAnimation={false}
          reachedEndMessage={null}
        />
      </div>
    );
  }
}
